import { namespaceConfigurationUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import {
  MachineGroup,
  UpdateMachineGroupPayload,
} from "@src/types/namespace-configuration";
import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "@src/cloud-connect/api/util/build-axios-authentication-headers";

export const patchUpdateMachineGroup = async (
  namespace: string,
  groupId: string,
  payload: UpdateMachineGroupPayload,
): Promise<MachineGroup> => {
  const url = namespaceConfigurationUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.patch<MachineGroup>(
      `${url}/api/v1/ns/${namespace}/machine-groups/${groupId}`,
      payload,
      { headers },
    );

    return response.data;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);
      throw new Error(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          "Failed to update machine group. Please try again later.",
      );
    }

    throw new Error(
      "An unexpected error occurred while updating machine group.",
    );
  }
};
